import type { AccountSummary } from "../Accounts.helpers.ts";
import { AccountRow } from "./AccountRow.tsx";
import type { AccountRowActions } from "./types.ts";

type AccountMenuProps = AccountRowActions & {
  summaries: AccountSummary[];
  filterSet: ReadonlySet<string>;
  linking: boolean;
  editingId: string | null;
  editingValue: string;
  saving: boolean;
  reconnectingId: string | null;
  onClearFilter: () => void;
  onConnect: () => void;
};

export function AccountMenu({
  summaries,
  filterSet,
  linking,
  editingId,
  editingValue,
  saving,
  reconnectingId,
  onClearFilter,
  onConnect,
  onToggleFilter,
  onStartEdit,
  onCancelEdit,
  onCommitEdit,
  onEditingValueChange,
  onReconnect,
  onSetDefault,
}: AccountMenuProps) {
  return (
    <div className="account-switcher-menu" role="menu">
      <div className="account-switcher-menu-header">
        <span>Contas conectadas</span>
        {filterSet.size > 0 ? (
          <button type="button" className="btn btn-link btn-compact" onClick={onClearFilter}>
            Limpar filtro
          </button>
        ) : null}
      </div>
      {summaries.map((summary) => (
        <AccountRow
          key={summary.sessionId}
          summary={summary}
          checked={filterSet.has(summary.sessionId)}
          isEditing={editingId === summary.sessionId}
          editingValue={editingValue}
          saving={saving}
          reconnecting={reconnectingId === summary.sessionId}
          onToggleFilter={onToggleFilter}
          onStartEdit={onStartEdit}
          onCancelEdit={onCancelEdit}
          onCommitEdit={onCommitEdit}
          onEditingValueChange={onEditingValueChange}
          onReconnect={onReconnect}
          onSetDefault={onSetDefault}
        />
      ))}
      <div className="account-switcher-actions">
        <button
          type="button"
          className="btn btn-secondary btn-compact"
          onClick={onConnect}
          disabled={linking}
        >
          {linking ? "Abrindo..." : "+ Conectar nova conta (Unipile)"}
        </button>
      </div>
    </div>
  );
}
